/* eslint-disable radix */
import React, { Component } from 'react';
import ConfiguracoesEmailPage from './email.page';
import ConfiguracaoApi from '../../configuracao.api';
import * as commonActions from '../../../../app/common/common.action';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class ConfiguracoesEmailContainer extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      smtp: '',
      password: '',
      porta: 587,
    };
  }

  getDefault() {}
  salvar(e) {
    e.preventDefault();
    const payload = {
      notificacaoEmail: this.state.email,
      notificacaoSmtp: this.state.smtp,
      notificacaoSenha: this.state.password,
      notificacaoPorta: this.state.porta,
    };
    this.props.commonActions.showFadeCarregando(true);
    ConfiguracaoApi.gravarConfigEmail(payload).then(() => {
      let mensagem = 'Configurações de Email salva com sucesso';
      this.props.commonActions.showAlerta(
        'sucesso',
        mensagem,
        2000,
        mensagem.length * 10 + 'px'
      );
      this.props.commonActions.showFadeCarregando(false);
    });
  }
  changeEmail(val) {
    this.setState({email: val});
  }
  changeSMTP(val) {
    this.setState({smtp: val});
  }
  changePassword(val) {
    this.setState({password: val});
  }
  changePorta(val) {
    this.setState({porta: val});
  }

  render() {
    return (

      <ConfiguracoesEmailPage
        email={this.state.email}
        smtp={this.state.smtp}
        password={this.state.password}
        porta={this.state.porta}
        salvar={this.salvar.bind(this)}
        changeEmail={this.changeEmail.bind(this)}
        changeSMTP={this.changeSMTP.bind(this)}
        changePassword={this.changePassword.bind(this)}
        changePorta={this.changePorta.bind(this)}
      />
    );
  }

  componentDidMount() {
    this.props.commonActions.showFadeCarregando(true);
    ConfiguracaoApi.getConfiguracaoEmail()
      .then((res) => {
        this.setState({
          email: res.notificacaoEmail,
          smtp: res.notificacaoSmtp,
          password: res.notificacaoSenha,
          porta: res.notificacaoPorta,
        });

        this.props.commonActions.showFadeCarregando(false);
      })
      .catch(() => {
        this.props.commonActions.showFadeCarregando(false);
      });
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfiguracoesEmailContainer);



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/email/email.container.js